// components/Quote.jsx
import React, { useState, useEffect } from 'react';
import { quoteApi } from '../../api/Quote';

const Quote = () => {
  const [quoteData, setQuoteData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchQuote = async () => {
      try {
        setLoading(true);
        setError(null);
        
        // Using the API service
        const result = await quoteApi.getFeaturedQuote();
        
        if (result.success) {
          setQuoteData(result.quote);
        } else {
          setError(result.error);
          // Fallback quote in case API fails
          setQuoteData({
            quote: "Start now. Not Monday. Not next month. Right now — or stay the same forever.",
            author: "Swapnil Gautam"
          });
        }
      } catch (error) {
        console.error("Error fetching quote:", error);
        setError(error.message);
        // Fallback quote
        setQuoteData({
          quote: "Start now. Not Monday. Not next month. Right now — or stay the same forever.",
          author: "Swapnil Gautam"
        });
      } finally {
        setLoading(false);
      }
    };

    fetchQuote();
  }, []);

  if (loading) {
    return (
      <div className="p-6 text-gray-400 animate-pulse text-center">
        Loading inspiration...
      </div>
    );
  }

  return (
    <div className="bg-white">
      {/* Main Card */}
      <div className="relative w-full bg-white overflow-hidden flex flex-col items-center justify-center p-8">
        
        {/* Top Right Corner Shape (Neon Green) */}
        <div className="absolute top-0 right-0 w-32 h-32 bg-[#CCFF00] rounded-bl-full translate-x-6 -translate-y-6"></div>

        {/* Bottom Left Corner Shape (Neon Green) */}
        <div className="absolute bottom-0 left-0 w-32 h-32 bg-[#CCFF00] rounded-tr-full -translate-x-6 translate-y-6"></div>

        {/* Quote Icon */}
        <div className="relative z-10 mb-6">
          <svg width="40" height="30" viewBox="0 0 40 30" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0 17.1429V0H14.2857V17.1429L8.57143 28.5714H0L5.71429 17.1429H0ZM22.8571 17.1429V0H37.1429V17.1429L31.4286 28.5714H22.8571L28.5714 17.1429H22.8571Z" fill="#CCFF00"/>
          </svg>
        </div>

        {/* Quote Content */}
        <div className="relative z-10 text-center">
          <p className="text-lg md:text-xl font-medium text-gray-900 leading-tight mb-4 px-2">
            "{quoteData?.quote || "Start now. Not Monday. Not next month. Right now — or stay the same forever."}"
          </p>
          
          <div className="flex items-center justify-center gap-2">
            <span className="text-[#CCFF00] text-xl font-bold">—</span>
            <span className="text-sm font-bold text-gray-800 tracking-wide uppercase">
              {quoteData?.author || "Swapnil Gautam"}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Quote;